import { ReactElement } from 'react'
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material'

type ProgressProps = {
  completed: number
  total: number
  title?: string
  size?: number
  fontSize?: number
}

export let MultiCircularProgress = ({
  completed,
  total,
  title,
  size = 48,
  fontSize = 13,
}: ProgressProps): ReactElement => {
  let overlayStyle = {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  let percentage =
    completed > total ? 100 : Math.round((100 * completed) / total)

  return (
    <Tooltip
      title={`${completed} / ${total}${title ? ` ${title}` : ''} Complete`}
      placement="left"
    >
      <span>
        <IconButton disabled>
          <Box sx={{ position: 'relative', display: 'flex' }}>
            <CircularProgress
              color="inherit"
              variant="determinate"
              value={100}
              size={size}
              aria-hidden={true}
            />
            <Box sx={overlayStyle}>
              <CircularProgress
                variant="determinate"
                value={Number.isNaN(percentage) ? 0 : percentage}
                size={size}
                color={percentage >= 100 ? 'success' : 'primary'}
                aria-label={`${completed} / ${total}${title ? ` ${title}` : ''} Complete`}
              />
            </Box>
            <Box sx={overlayStyle}>
              <Typography color="textPrimary" sx={{ fontSize }}>
                {Number.isNaN(percentage)
                  ? 'N/A'
                  : `${Math.round(percentage)}%`}
              </Typography>
            </Box>
          </Box>
        </IconButton>
      </span>
    </Tooltip>
  )
}
